import { bwv846 } from './pieces/bwv846';
import { PATHS, pathById } from './paths';
import { FEELINGS } from './feelings';
import { choralePiece } from './chorales';
import { sonataPiece } from './sonatas';
import type { Moment, PieceData } from './types';

/** Hand-annotated flagship pieces. Chorales and sonata movements are derived on demand (see ./chorales, ./sonatas). */
export const PIECES: Record<string, PieceData> = { [bwv846.id]: bwv846 };

export function pieceById(id: string): PieceData | undefined {
  return PIECES[id] ?? choralePiece(id) ?? sonataPiece(id);
}

export function momentRef(ref: string): { piece: PieceData; moment: Moment } | null {
  const [pieceId, momentId] = ref.split(':');
  const piece = pieceById(pieceId);
  const moment = piece?.moments.find((m) => m.id === momentId);
  return piece && moment ? { piece, moment } : null;
}

export { PATHS, pathById, FEELINGS };
export type * from './types';
